import React from "react";
import { FieldProps } from "@rjsf/utils";
import { UniqueIdInput } from "../../../../../../Submissions/Fields";
import BaseFieldPreview from "./BaseFieldPreview";

const UniqueIdFieldPreview = (props: FieldProps) => {
  let newPlaceholder = props.uiSchema?.["ui:prefix"] || "";

  newPlaceholder = newPlaceholder.replace(
    "{{year}}",
    new Date().getFullYear().toString(),
  );

  const numberType = props.uiSchema?.["ui:numberType"] || "ascending";
  if (numberType === "ascending") {
    newPlaceholder += "12345";
  } else {
    newPlaceholder += "41352";
  }

  const updatedProps = {
    ...props,
    uiSchema: {
      ...props.uiSchema,
      "ui:placeholder": newPlaceholder,
    },
  };
  const widgetPreview = <UniqueIdInput {...updatedProps} />;
  return <BaseFieldPreview widgetPreview={widgetPreview} {...updatedProps} />;
};

export default UniqueIdFieldPreview;
